import BaseTheme from '../../index'
import { space, breakpoints, colors } from './core'
import {
  fontUrls, fonts, textStyles, texts
} from './typography'
import { buttons, buttonSizes } from './buttons'
import { inputs, dateOfBirthSeperator } from './inputs'
import dropdowns from './dropdowns'
import checkboxes from './checkboxes'
import questionsAndHints from './questions-and-hints'
import radios from './radios'
import progressBar from './progress-bar'
import bullet from './bullets'
import accordion from './accordion'
import privacyNotice from './privacy-notice'

const zuto: BaseTheme = {
  space,
  breakpoints,
  colors,
  fontUrls,
  fonts,
  textStyles,
  texts,
  buttons,
  buttonSizes,
  inputs,
  dateOfBirthSeperator,
  dropdowns,
  checkboxes,
  questionsAndHints,
  radios,
  progressBar,
  bullet,
  accordion,
  privacyNotice
}

export default zuto
